module.exports = __webpack_public_path__ + "media/info_place.eb023953.mp4";